<template>
  <v-app id="app">
    <NotificationsNewsDrawer
      v-if="
        isLocalOrDevEnv() &&
        isAuthenticated &&
        settingsDevStore.canModeFeature('NEWS_LIST')
      "
    />
    <DevSettingsDrawer v-if="isLocalOrDevEnv()" />

    <ContainerCenteredFull v-if="globalStore.fetchInitialPending">
      <AppLoaderLogo />
    </ContainerCenteredFull>
    <template v-else>
      <router-view />
    </template>
    <Toaster
      close-button
      close-button-position="top-right"
      position="top-right"
      rich-colors
    />
    <DeepLoader />
    <DeepReloadPrompt v-if="!isLocalEnv()" />
    <!-- Overused subscription blocking overlay -->
    <OverlayOverusedSubscription />
    <!-- /Overused subscription blocking overlay -->
  </v-app>
</template>
<script lang="ts" setup>
import AppLoaderLogo from '@/components/app/AppLoaderLogo.vue'
import ContainerCenteredFull from '@/components/containers/ContainerCenteredFull.vue'
import DevSettingsDrawer from '@/components/dev/DevSettingsDrawer.vue'
import NotificationsNewsDrawer from '@/components/notifications/NotificationsNewsDrawer.vue'
import OverlayOverusedSubscription from '@/components/overlays/OverlayOverusedSubscription.vue'
import 'vue-sonner/style.css'
import { Toaster } from 'vue-sonner'
import { isLocalEnv, isLocalOrDevEnv } from '@/utils/helpers/env'
import {
  DeepLoader,
  DeepReloadPrompt,
  useAppTheme,
} from '@deepcloud/deep-ui-lib'
import { useDeepAdminUsersCompanyAccountingStore } from '@/stores/deepadmin/users/users-company-accounting.ts'
import { useGlobalStore } from '@/stores/global/global'
import { useSettingsDevStore } from '@/stores/settings/settings-dev'
import { useAppLocale } from '@/composables/app-locale'
import { useKeycloak } from '@/composables/auth/keycloak'
import { useDialogSessionInvalid } from '@/composables/dialog-session-invalid'
import { useOrganization } from '@/composables/organization/organization'
import { useSeoI18n } from '@/composables/seo-i18n.ts'

const globalStore = useGlobalStore()
const settingsDevStore = useSettingsDevStore()

const { setCurrentTheme } = useAppTheme()
setCurrentTheme()

const { isAuthenticated } = useKeycloak()
useAppLocale()
useDialogSessionInvalid()

useSeoI18n()

const deepAdminUsersCompanyAccountingStore =
  useDeepAdminUsersCompanyAccountingStore()
const { currentContextOrgId } = useOrganization()
watch(
  () => currentContextOrgId.value,
  async (newValue) => {
    deepAdminUsersCompanyAccountingStore.$reset()
    if (newValue) {
      void deepAdminUsersCompanyAccountingStore.fetchCompanyAccounting(newValue)
    }
  },
  { immediate: true },
)
</script>
